// import SurveyHeader from "components/SurveyComponents/Header/SurveyHeader";
import SurveyBody from "components/SurveyComponents/SurveyBody/SurveyBody";
import React from "react";

const UserSurvey = () => {
  return <SurveyBody />;
};

export default UserSurvey;
